<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'repository.containers.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form">
      <button *ngIf="!isCreationMode" (click)="onEdit()" [matTooltip]="'repository.containers.list.add' | translate"
        mat-mini-fab class="action-button" color="primary">
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-container-edit *ngIf="isCreationMode && !editedId" (editFinished)="onEditFinished()"></app-container-edit>
    </section>

    <mat-form-field class="filterField">
      <mat-label>Filtrer</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Votre filtre" #input>
    </mat-form-field>

    <section class="datatable-container">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="identifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.containers.list.identifier' | translate
            }} </th>
          <td mat-cell *matCellDef="let container"> {{ container.identifier }} </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.containers.list.description' | translate
            }} </th>
          <td mat-cell *matCellDef="let container"> {{ container.description }} </td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.containers.list.client' | translate }}
          </th>
          <td mat-cell *matCellDef="let container"> {{ container.client?.name }} </td>
        </ng-container>

        <ng-container matColumnDef="tag">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> KooveaTag </th>
          <td mat-cell *matCellDef="let container"> {{ container.tag }} </td>
        </ng-container>

        <ng-container matColumnDef="productType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.containers.list.productType' | translate
            }} </th>
          <td mat-cell *matCellDef="let container"> {{ container.productType?.name }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'repository.containers.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let container">
            <ng-container *ngIf="container.id !== editedId">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'repository.containers.list.edit' | translate" (click)="onEdit(container.id)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container>
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'repository.containers.list.delete' | translate" (click)="delete(container.id)">
                <mat-icon aria-label="Delete">delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let container" [attr.colspan]="displayedColumns.length">
            <div *ngIf="container.id === editedId" class="row-edit"
              [@detailExpand]="container.id === editedId ? 'expanded' : 'collapsed'">
              <app-container-edit [container]="container" (editFinished)="onEditFinished()"></app-container-edit>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
          [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons></mat-paginator>
    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
  </mat-card-content>
</mat-card>